import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { Trash2, Mail, Phone, User, CheckCheck } from 'lucide-react';
import AuthorAvatar from '../common/AuthorAvatar';
import { contactApi } from '../../utils/api';

// सम्पर्क फारम bata aayeka sabai messages ko vyavasthapan
function AdminContacts() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAll();
  }, []);

  const fetchAll = async () => {
    setLoading(true);
    try {
      const res = await contactApi.getAll();
      setMessages(res.data || []);
    } catch (error) {
      console.error('Error fetching contacts:', error);
    } finally {
      setLoading(false);
    }
  };

  const markRead = async (id) => {
    try {
      await contactApi.markRead(id);
      setMessages((ms) => ms.map((m) => (m.id === id ? { ...m, is_read: 1 } : m)));
    } catch (error) {
      toast.error('अपडेट असफल भयो।');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('के तपाईं यो सन्देश मेटाउन निश्चित हुनुहुन्छ?')) return;
    try {
      await contactApi.remove(id);
      toast.success('सन्देश मेटियो।');
      setMessages((ms) => ms.filter((m) => m.id !== id));
    } catch (error) {
      toast.error('मेटाउन असफल भयो।');
    }
  };

  if (loading) {
    return <div className="text-center py-16 text-muted">लोड हुँदै...</div>;
  }

  const unread = messages.filter((m) => !m.is_read).length;

  return (
    <div>
      <div className="flex items-center justify-between gap-3 flex-wrap mb-5">
        <h2 className="font-display text-2xl">सम्पर्क सन्देशहरू</h2>
        {unread > 0 && (
          <span className="text-[12px] font-bold bg-crimson text-white px-3 py-1.5 rounded-full">
            {unread} नपढिएका
          </span>
        )}
      </div>

      <div className="flex flex-col gap-3">
        {messages.map((m) => (
          <div
            key={m.id}
            className={`bg-white border rounded-xl p-4 ${m.is_read ? 'border-line opacity-80' : 'border-crimson/40 shadow-sm'}`}
          >
            <div className="flex items-start gap-3">
              <AuthorAvatar name={m.name || m.email || 'P'} size={38} />
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap text-[13.5px] font-bold text-ink mb-1.5">
                  <span className="flex items-center gap-1"><User size={12} /> {m.name || 'अज्ञात'}</span>                  {!m.is_read && <span className="w-2 h-2 rounded-full bg-crimson" />}
                  <span className="text-[11.5px] font-normal text-muted">{new Date(m.created_at).toLocaleString()}</span>
                </div>
                <div className="flex gap-4 flex-wrap text-[12.5px] text-muted mb-2">
                  {m.email && (
                    <a href={`mailto:${m.email}`} className="flex items-center gap-1 hover:text-crimson">
                      <Mail size={12} /> {m.email}
                    </a>
                  )}
                  {m.phone && (
                    <a href={`tel:${m.phone}`} className="flex items-center gap-1 hover:text-crimson">
                      <Phone size={12} /> {m.phone}
                    </a>
                  )}
                </div>
                <p className="text-[13.5px] text-ink-soft leading-relaxed whitespace-pre-line break-words">{m.message}</p>
              </div>
              <div className="flex flex-col gap-1.5 flex-shrink-0">
                {!m.is_read && (
                  <button
                    className="inline-flex items-center justify-center w-9 h-9 rounded-[10px] hover:bg-green-50 hover:text-green-700"
                    onClick={() => markRead(m.id)}
                    aria-label="Mark as read"
                    title="पढियो भनी चिनो लगाउनुहोस्"
                  >
                    <CheckCheck size={16} />
                  </button>
                )}
                <button
                  className="inline-flex items-center justify-center w-9 h-9 rounded-[10px] hover:bg-red-50 hover:text-crimson"
                  onClick={() => handleDelete(m.id)}
                  aria-label="Delete"
                >
                  <Trash2 size={16} />
                </button>
              </div>
            </div>
          </div>
        ))}
        {messages.length === 0 && <p className="text-muted py-6 text-center">अहिलेसम्म कुनै सन्देश आएको छैन।</p>}
      </div>
    </div>
  );
}

export default AdminContacts;
